import { defineNuxtPlugin, useState, watch } from "#imports";
import getLoader from "#nuxt-easy-texts/loader";
export default defineNuxtPlugin({
  name: "nuxt-easy-texts",
  setup: async () => {
    const loader = getLoader();
    const isDebug = useState("nuxt_easy_texts_debug_enabled", () => false);
    const translations = useState(
      "nuxt_easy_texts",
      () => {
        return null;
      }
    );
    if (!translations.value) {
      translations.value = await loader.load();
    }
    const getSingleText = (key) => {
      if (translations.value) {
        const candidate = translations.value[key];
        if (typeof candidate === "string") {
          return candidate;
        } else if (Array.isArray(candidate)) {
          return candidate[0] || key;
        }
      }
      return key;
    };
    const getPluralTexts = (key) => {
      if (translations.value) {
        const candidate = translations.value[key];
        if (Array.isArray(candidate) && candidate.length === 2) {
          return [candidate[0], candidate[1]];
        }
      }
      return [key, key];
    };
    if (import.meta.client && loader.reloadTrigger) {
      const trigger = loader.reloadTrigger();
      watch(trigger, async () => {
        translations.value = await loader.load();
      });
    }
    return {
      provide: {
        texts: (key, _defaultText) => {
          if (isDebug.value) {
            return key;
          }
          return getSingleText(key);
        },
        textsPlural: (key, count, _singular, _plural) => {
          if (isDebug.value) {
            return key;
          }
          const [singular, plural] = getPluralTexts(key);
          return count === 1 ? singular : plural.replace("@count", count.toString());
        }
      }
    };
  }
});
